class BillingVisualModel {
  constructor() {
    this.logo = '';
    this.signature = '';
    this.mainColor = '';
  }
}

export default BillingVisualModel;
